/**
 * Created by sagardesai on 12/07/18.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../../actions/index';

import {formattedPrice, getFormattedPrice, isEmpty, removeAllModalPopUps, vuepayAlert} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";
import {getEncryptedIdForBroadcaster} from "../../util/broadcast_util"
import {updateJWTToken} from "../../util/broadcast/create";
import {getMoneyBloxWalletBalance} from '../../assets/libs/MoneyBlox'
//image
import loading_white from '../../assets/gif/loading_white.gif';
import assets from "../../util/assets";


class JoinBroadcastConfirmationModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            wallet_balance:"0.00"
        }
        //all the functions used in this component should be listed here for better documentation

    }

    componentDidMount(){
        if (this.props.moneyblox.hasOwnProperty("wallet_balance") &&
            this.props.moneyblox.hasOwnProperty("user_details") &&
            this.props.moneyblox.user_details !== null) {

            this.setState({
                wallet_balance:this.props.moneyblox.wallet_balance
            })
        }
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.hasOwnProperty("join_broadcast") &&
            nextProps.join_broadcast.hasOwnProperty("payload") &&
            nextProps.join_broadcast.payload !== null) {
            if (nextProps.join_broadcast.isSuccess) {
                updateJWTToken(nextProps.join_broadcast.payload, () => {
                    this.props.initializeTokBox(nextProps.join_broadcast.payload.data);
                    const broadcastID = getEncryptedIdForBroadcaster(this.state.broadcaster.broadcast[0].id);
                    this.props.history.push(`/view/broadcast?session_id=${nextProps.join_broadcast.payload.data.session_id}&broadcast_id=${broadcastID}&token=${nextProps.join_broadcast.payload.data.token}`,
                        {
                            state: {
                                broadcaster: this.state.broadcaster,
                                is_in_private_session: this.props.isPrivateSession,
                                sessionDetail: nextProps.join_broadcast.payload
                            }
                        })
                });


            } else if (nextProps.join_broadcast.isError) {
                vuepayAlert("error", nextProps.join_broadcast.payload.message);
            }
            this.props.resetJoinBroadcast()
        }

        //Join private broadcast response - to get latest session id and token
        if (nextProps.hasOwnProperty("join_broadcast") &&
            nextProps.join_broadcast.hasOwnProperty("privateBroadcastPayload") &&
            nextProps.join_broadcast.privateBroadcastPayload !== null) {
            if (nextProps.join_broadcast.isSuccess) {

                updateJWTToken(nextProps.join_broadcast.privateBroadcastPayload, () => {
                    this.props.initializeTokBox(nextProps.join_broadcast.privateBroadcastPayload.data);
                    const broadcastID = getEncryptedIdForBroadcaster(this.state.tempNewBroadcastId);
                    removeAllModalPopUps()
                    this.props.history.push(`/view/broadcast?session_id=${nextProps.join_broadcast.privateBroadcastPayload.data.session_id}&broadcast_id=${broadcastID}&token=${nextProps.join_broadcast.payload.data.token}`, {

                            broadcaster: this.state.broadcaster,
                            sessionDetail: nextProps.join_broadcast.privateBroadcastPayload,
                            is_in_private_session: true,

                    })
                });


            }
            else if (nextProps.join_broadcast.isError) {
                vuepayAlert("error", nextProps.join_broadcast.payload.message);
            }
            this.props.resetJoinPrivateBroadcast()
        }

        //MoneyBlox
        if (nextProps.moneyblox.hasOwnProperty("wallet_balance") &&
            nextProps.moneyblox.hasOwnProperty("user_details") &&
            nextProps.moneyblox.user_details !== null) {
            this.setState({
                wallet_balance:this.props.moneyblox.wallet_balance
            })
        }

        if (this.props.moneyblox.wallet_balance !== nextProps.moneyblox.wallet_balance) {
            this.setState({
                wallet_balance: nextProps.moneyblox.wallet_balance
            })
        }

        if (this.props.isVisible != nextProps.isVisible){
            if (nextProps.isVisible){
                getMoneyBloxWalletBalance(this.props, true);
            }
        }
    }

    apiCallForJoinBroadcast = () => {

        if (this.props.isPrivateSession) {
            if ((this.state.wallet_balance * 100) < this.props.broadcaster.broadcast[0].one_to_one_session_price) {
                vuepayAlert("error", `Please make sure to have at least ${formattedPrice(this.props.broadcaster.broadcast[0].one_to_one_session_price)} to join this session`);
                return
            }

        } else {
            if ((this.state.wallet_balance * 100) < this.props.broadcaster.broadcast[0].group_session_price) {
                vuepayAlert("error", `Please make sure to have at least ${formattedPrice(this.props.broadcaster.broadcast[0].group_session_price)} to join this session`);
                return
            }
        }

        getData(LOGIN)
            .then((data) => {
                const jsonData = {
                    device: this.props.device
                }
                if (!isEmpty(data)) {
                    if (this.props.endCurrentSession) {
                        const waitForDisconnect = 500; //0.5 secs
                        this.props.endCurrentSession()
                        setTimeout(() => {
                            //join new/updated broadcast
                            if (this.props.isPrivateSession) {
                                this.props.joinPrivateBroadcast(data.token, data.api_token, this.props.broadcaster.broadcast[0].id, jsonData)
                            }
                            else {
                                this.props.joinBroadcast(data.token, data.api_token, this.props.broadcaster.broadcast[0].id, jsonData)
                            }
                        }, waitForDisconnect)
                    }
                    else {
                        if (this.props.isPrivateSession) {
                            this.props.joinPrivateBroadcast(data.token, data.api_token, this.props.broadcaster.broadcast[0].id, jsonData)
                        }
                        else {
                            this.props.joinBroadcast(data.token, data.api_token, this.props.broadcaster.broadcast[0].id, jsonData)
                        }
                    }
                }
            })
    }

    render() {
        return (
            <div id="join-broadcast-confirmation" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
                 aria-hidden="true">
                <div className="vertical-alignment-helper">
                    <div className="modal-dialog vertical-align-center">
                        <div className="modal-content">
                            <div className="modal-header">
                                {!this.props.hideCrossButton &&
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        onClick={this.props.toggleJoinBroadcastModal}><img alt={"close-icon"} src={assets.broadcast.cross}/>
                                </button>}
                            </div>
                            <div className="modal-body">
                                <div className="followers-img-wrapper">
                                    <div className="followers-img">
                                        <img src={this.props.broadcaster.profile_pic} alt="followers"/>
                                    </div>
                                </div>
                                <h5>{this.props.broadcaster.username}</h5>
                                <p>{this.props.title}</p>
                                {/*<p className="font-weight-bold">Are you entering a ... session?</p>*/}
                                {
                                    this.props.isPrivateSession ?
                                        <div className="border-box">
                                            <p>Private session charge</p>
                                            <p>
                                                <strong>{getFormattedPrice(this.props.broadcaster.broadcast[0].one_to_one_session_price)}</strong>
                                            </p>
                                            <p className="mt-3">Your credit</p>
                                            {
                                                (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null)
                                                    ?
                                                    <p className="text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        this.props.showMoneyBloxModal()
                                                    }}>£ 0.00</p>
                                                    :
                                                    <p><strong>£{this.state.wallet_balance}</strong></p>
                                            }
                                        </div>
                                        :
                                        <div className="border-box">
                                            <p>{this.props.broadcaster.broadcast[0].broadcast_type === "free" ? "Free session" : "Group session charge"}</p>
                                            {this.props.broadcaster.broadcast[0].broadcast_type === "paid" && <p>
                                                <strong>{getFormattedPrice(this.props.broadcaster.broadcast[0].group_session_price)}</strong>
                                            </p>}
                                            <p className="mt-3">Your credit</p>
                                            {
                                                (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null)
                                                    ?
                                                    <p className="text-danger" style={{cursor: 'pointer'}} onClick={() => {
                                                        this.props.showMoneyBloxModal()
                                                    }}>£ 0.00</p>
                                                    :
                                                    <p><strong>£{this.state.wallet_balance}</strong></p>
                                            }

                                        </div>
                                }
                            </div>
                            <div className="modal-footer">

                                {
                                    (this.state.wallet_balance === "0.00" || this.props.moneyblox.user_details === null) && this.props.broadcaster.broadcast[0].broadcast_type !== "free" ?
                                        <button type="button" className="btn btn-outline-primary" disabled>Confirm session</button>
                                        :
                                        <button type="button" className="btn btn-outline-primary"
                                                onClick={this.apiCallForJoinBroadcast}>
                                            {
                                                this.props.join_broadcast.isFetching
                                                    ?
                                                    <img src={loading_white} alt={"Loading"} width={26} height={26}/>
                                                    :
                                                    "Confirm session"
                                            }
                                        </button>
                                }

                                {
                                    (this.props.moneyblox.user_details === null) ?
                                        <button type="button" className="btn btn-link" style={{cursor:'not-allowed'}} disabled>Add Credit</button>
                                        :
                                        <button type="button" className="btn btn-link" onClick={() => {
                                            this.props.showMoneyBloxModal()
                                        }} >Add Credit</button>
                                }

                                {this.props.hideCrossButton &&
                                <button type="button" className="btn btn-link" data-dismiss="modal"
                                        onClick={this.props.disconnectOTSession}>Exit Session</button>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownParams) {
    return {
        join_broadcast: state.join_broadcast,
        device: state.device.payload,
        moneyblox: state.moneyblox

    };
}

export default connect(mapStateToProps, actions)(JoinBroadcastConfirmationModal);